<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6" sm="6" v-for="(port,k) in ports" :key="k">
        <div class="brand-card">
          <div class="brand-card-header">
            <button
              @click="selectPort(port)"
              type="button"
              class="btn btn-secondary"
              v-bind:class="{ 'btn-success': portCode===port.code}"
            >{{port.name.toUpperCase()}}</button>
          </div>
          <div class="brand-card-body">
            <div>
              <span
                v-if="port.ratio_updated"
                v-b-popover.hover.top="formatDateTime(port.ratio_updated)"
                title="Última actualización"
              >
                <div class="text-value">{{port.ratio}}</div>
              </span>
              <div class="text-uppercase text-muted small">RATIO</div>
              <button class="btn btn-sm btn-primary" @click="calcRatio(port.id)">Calcular</button>
            </div>
            <div>
              <span
                v-if="port.cycle_time_updated"
                v-b-popover.hover.top="formatDateTime(port.cycle_time_updated)"
                title="Última actualización"
              >
                <div class="text-value">{{port.format_cycle_time}}</div>
              </span>
              <div class="text-uppercase text-muted small">TIEMPO DE CICLO</div>
              <button class="btn btn-sm btn-primary" @click="calcCycleTime(port.id)">Calcular</button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card header="Porteo">
          <div slot="header">
            Porteo
            <div class="card-header-actions">
              <!-- <b-link href="#" class="card-header-action btn-setting">
                <i class="icon-settings"></i>
              </b-link>-->
              <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                <i class="icon-arrow-up"></i>
              </b-link>
            </div>
          </div>
          <b-collapse id="collapse1" visible>
            
            <div class="form-group form-inline pull-left">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    v-bind:class="serviceSelected === 'IMPO' ? 'active':''"
                    @click="selectService('IMPO')"
                  >DESCARGA</a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    v-bind:class="serviceSelected === 'EXPO' ? 'active':''"
                    @click="selectService('EXPO')"
                  >EMBARQUE</a>
                </li>
              </ul>
            </div>
            <div class="form-group form-inline pull-right">
              <input v-model="search" type="search" class="form-control" placeholder="Filtrar..." /> &nbsp;
              <date-picker
                v-model="date.start"
                lang="es"
                type="date"
                placeholder="Desde"
                format="DD/MM/YYYY"
              ></date-picker> &nbsp;
              <date-picker
                v-model="date.end"
                lang="es"
                type="date"
                placeholder="Hasta"
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <button class="btn btn-primary" @click="getPortages()">Buscar</button>
            </div>
            <div class="table-responsive">
              <h5>En proceso</h5>
              <table class="table table-striped table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th>NAVE</th>
                    <th>RECALADA</th>
                    <!-- <th>OPERACION</th> -->
                    <th>{{serviceSelected === 'EXPO' ? 'STACKING' : 'TD'}}</th>
                    <th>{{serviceSelected === 'EXPO' ? 'CUTOFF' : 'CIERRE'}}</th>
                    <th>OPERACIONES</th>
                    <th>CAMIONES NECESARIOS</th>
                    <th>AVANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- @contextmenu.prevent="selectRq(portage)" -->
                  <tr
                    v-for="(portage, k) in filteredRqs"
                    :key="k"
                    @contextmenu.prevent="selectPortage(portage)"
                  >
                    <td>{{portage.ship_name}}</td>
                    <td>{{portage.recalada}}</td>
                    <!-- <td>{{portage.operation.name}}</td> -->
                    <td>{{(portage.operation.code_service === constants.EXPORTACION ? portage.stacking : portage.td) | formatDateTime}}</td>
                    <td>{{portage.cutoff | formatDateTime}}</td>
                    <td>
                      <div v-for="(ct, k) in charge_types" :key="k">
                        <span
                          class="badge badge-primary"
                          v-if="qtyChargeType(portage , ct) > 0"
                        >{{ct.name}}: {{qtyChargeType(portage, ct)}}</span>
                      </div>
                    </td>
                    <td align="center">{{portage.total_trucks}}</td>
                    <td>
                      <div class="progress-group">
                        <div class="progress-group-header">
                          <i class="fa fa-truck progress-group-icon"></i>
                          <div>{{portage.containers.reduce((acum, ctn) => acum + ctn.used, 0)}} / {{portage.containers.length}}</div>
                        </div>
                        <div class="progress-group-bars">
                          <div class="progress">
                            <!-- <div
                              class="progress-bar"
                              v-bind:class="[portage.progress_containers == portage.total_containers ? 'bg-success' : 'bg-warning']"
                              role="progressbar"
                              v-bind:style="{ width: portage.progress_containers/portage.total_containers*100 + '%' }"
                              v-bind:aria-valuenow="portage.progress_containers/portage.total_containers*100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div> -->
                            <div
                              class="progress-bar"
                              v-bind:class="[portage.containers.reduce((acum, ctn) => acum + ctn.used, 0) >= portage.containers.length ? 'bg-success' : 'bg-warning']"
                              role="progressbar"
                              v-bind:style="{ width: portage.containers.reduce((acum, ctn) => acum + ctn.used, 0) / portage.containers.length*100 + '%' }"
                              v-bind:aria-valuenow="portage.containers.reduce((acum, ctn) => acum + ctn.used, 0) / portage.containers.length*100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5" align="right">TOTALES:</td>
                    <td
                      align="center"
                      class="total"
                    >{{ filteredRqs.reduce((prev,next) => prev + next.total_trucks,0) }}</td>
                    <td
                      align="center"
                      class="total"
                    >{{ totalPending }}</td>
                  </tr>
                </tfoot>
              </table>
              <context-menu id="context-menu" ref="ctxMenu">
                <li v-on:click="openModalContainers" class="ctx-item">Ver contenedores</li>
                <li v-on:click="openModalDates" class="ctx-item">Editar fechas</li>
              </context-menu>
            </div>
            <div class="table-responsive">
              <h5>Finalizados</h5>
              <table class="table table-striped table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th>NAVE</th>
                    <th>RECALADA</th>
                    <!-- <th>OPERACION</th> -->
                    <th>{{serviceSelected === 'EXPO' ? 'STACKING' : 'TD'}}</th>
                    <th>{{serviceSelected === 'EXPO' ? 'CUTOFF' : 'CIERRE'}}</th>
                    <th>OPERACIONES</th>
                    <th>AVANCE</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- @contextmenu.prevent="selectRq(portage)" -->
                  <tr
                    v-for="(portage, k) in filteredRqsFinished"
                    :key="k"
                  >
                    <td>{{portage.ship_name}}</td>
                    <td>{{portage.recalada}}</td>
                    <!-- <td>{{portage.operation.name}}</td> -->
                    <td>{{(portage.operation.code_service === constants.EXPORTACION ? portage.stacking : portage.td) | formatDateTime}}</td>
                    <td>{{portage.cutoff | formatDateTime}}</td>
                    <td>
                      <div v-for="(ct, k) in charge_types" :key="k">
                        <span
                          class="badge badge-primary"
                          v-if="qtyChargeType(portage , ct) > 0"
                        >{{ct.name}}: {{qtyChargeType(portage, ct)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="progress-group">
                        <div class="progress-group-header">
                          <i class="fa fa-truck progress-group-icon"></i>
                          <div>{{portage.containers.reduce((acum, ctn) => acum + ctn.used, 0)}} / {{portage.containers.length}}</div>
                        </div>
                        <div class="progress-group-bars">
                          <div class="progress">
                            <div
                              class="progress-bar"
                              v-bind:class="[portage.containers.reduce((acum, ctn) => acum + ctn.used, 0) >= portage.containers.length ? 'bg-success' : 'bg-warning']"
                              role="progressbar"
                              v-bind:style="{ width: portage.containers.reduce((acum, ctn) => acum + ctn.used, 0) / portage.containers.length*100 + '%' }"
                              v-bind:aria-valuenow="portage.containers.reduce((acum, ctn) => acum + ctn.used, 0) / portage.containers.length*100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5" align="right">TOTALES:</td>
                    <td
                      align="center"
                      class="total"
                    >{{ totalFinished }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>

    <ModalDates
      v-if="showModalDates"
      :serviceSelected="serviceSelected"
      :showModalDates="showModalDates"
      :portage="portage"
      :updateDates="updateDates"
      @close="showModalDates = false"
    />
    <ModalContainers 
      v-if="showModalContainers"
      :showModalContainers="showModalContainers"
      :containers="portage.containers"
      :recalada="portage.recalada"
      @removeContainer="removeContainer"
      @close="showModalContainers = false"
    />
    <div v-if="showModalDates || showModalContainers" class="modal-backdrop fade show"></div>

    <Calendar :serviceSelected="serviceSelected" :port="port" :portages="filteredRqs" />
  </div>
</template>

<script>
import api from "@/helpers/api";
import moment from "moment";
import contextMenu from "vue-context-menu";
import Kpis from "@/views/ports/Kpis";
import Calendar from "@/views/portages/Calendar";
import ModalDates from "@/views/portages/ModalDates";
import ModalContainers from "@/views/portages/ModalContainers";

import constants from "@/constants";
export default {
  components: { contextMenu, Kpis, Calendar, ModalDates, ModalContainers },
  data() {
    return {
      portages: [],
      ports: [],
      charge_types: [],
      portCode: "DPW",
      requeriment: {},
      paginate: ["filteredRqs"],
      search: "",
      constants: "",
      port: {},
      serviceSelected: "IMPO",
      showModalDates: false,
      showModalContainers: false,
      portage: { td: "", stacking: "", cutoff: "" },
      date: {
        start: moment().add(-2, 'days').format('YYYY-MM-DD 00:00:00'),
        end: moment().add(2, 'days').format('YYYY-MM-DD 23:59:59')
      }
    };
  },
  mounted() {
    this.constants = constants;
    this.getPortages();
    api.get("/charge_types").then(response => {
      this.charge_types = response.charge_types;
    });

    api.get("/ports").then(response => {
      this.ports = response.ports;
      this.port = this.ports.find(pt => pt.code === this.portCode);

      this.ports.map((port, i) => {
        var minutes = port.cycle_time;

        if (minutes > 0) {
          var d = moment.duration(minutes, "minutes").asHours();
          var dur = moment.duration(d, "hours");

          var hours = Math.floor(dur.asHours());
          var mins = minutes - hours * 60;

          port.format_cycle_time =
            (hours > 9 ? hours : "0" + hours) +
            ":" +
            (mins > 9 ? mins : "0" + mins);
        } else {
          port.format_cycle_time = "00:00";
        }
        return port;
      });
    });
  },
  methods: {
    getPortages(){
      let data = {
        start: moment(this.date.start).format('YYYY-MM-DD 00:00:00'),
        end: moment(this.date.end).format('YYYY-MM-DD 23:59:59'),
      }
      api.post("/get_portages", data).then(response => {
        this.portages = response.portages;
      });
    },
    selectPort(port) {
      this.portCode = port.code;
      this.port = port;
    },
    selectService(service) {
      this.serviceSelected = service;
    },
    selectPortage(portage) {
      this.portage = portage;
      this.$refs.ctxMenu.open();
    },
    openModalDates() {
      this.showModalDates = true;
    },
    openModalContainers() {
      this.showModalContainers = true;
    },
    removeContainer(container_id){
      let index = this.portage.containers.findIndex(ctn => ctn.id == container_id)
      this.portage.containers.splice(index, 1)
    },
    qtyChargeType(portage, ct) {
      return portage.containers.reduce(function(cnt, ctr) {
        return cnt + (ctr.charge_type_id == ct.id ? 1 : 0);
      }, 0);
    },
    // newPortage() {
    //   this.$router.push({
    //     path: `/portage/new`
    //   });
    // },
    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    calcCycleTime(port_id) {
      api.get(`/cycle_time/${port_id}`).then(
        response => {
          this.$toastr.success(
            "Tiempo de ciclo calculado exitosamente",
            "Porteo",
            { positionClass: "toast-top-center", closeButton: true }
          );
        },
        error => {
          this.$toastr.error(error.message, "Porteo", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        }
      );
    },
    calcRatio(port_id) {
      api.get(`/ratio/${port_id}`).then(
        response => {
          this.$toastr.success("Ratio calculado exitosamente", "Porteo", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        },
        error => {
          this.$toastr.error(error.message, "Porteo", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        }
      );
    },
    selectRq(rq) {
      this.requeriment = rq;
      this.$refs.ctxMenu.open();
    },
    goDetail() {
      this.$router.push({
        path: `/portage/detail/${this.requeriment.id}`
      });
    },
    goEdit() {
      let current_date = moment().format("YYYY-MM-DD HH:mm:ss");
      let current_time = moment().format("HH:mm:ss");
      let next_date = moment()
        .add(1, "day")
        .format("YYYY-MM-DD");
      let service_date = moment(this.requeriment.landing_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      if (current_date >= service_date) {
        this.$toastr.warning(
          "No es posible editar un servicio pasado o en proceso",
          "Porteo",
          { positionClass: "toast-top-center", closeButton: true }
        );
      } else {
        this.$router.push({
          path: `/portage/edit/${this.requeriment.id}`
        });
      }
    },
    updateDates(data) {
      api.put(`/service/${this.portage.id}`, data).then(response => {
        this.$toastr.success("Fechas actualizadas.", "Porteo", {
          positionClass: "toast-top-center",
          closeButton: true
        });
        let index = this.portages.findIndex(p => p.id === this.portage.id);
        this.portages[index].cutoff = response.service.cutoff;
        this.portages[index].td = response.service.td;
        this.portages[index].stacking = response.service.stacking;
      });
    },
    filterPortage(filterByService){
      return filterByService.filter(portage => {
        if (!this.search) return true;

        const searchWord = this.search.toLowerCase();
        return (
          portage.ship_name.toLowerCase().includes(searchWord) ||
          portage.recalada.toLowerCase().includes(searchWord) ||
          portage.operation.name.toLowerCase().includes(searchWord)
        );
      });
    }
  },
  computed: {
    filteredRqs() {
      const { serviceSelected, portages, search, portCode } = this;
      const filterByService = portages.filter(
        pt =>
          pt.operation.code_service === serviceSelected &&
          pt.port.code === portCode && 
          pt.containers.length > pt.containers.reduce((acum, ctn) => acum + ctn.used ,0)
          // pt.total_containers > pt.progress_containers
      );
      return this.filterPortage(filterByService)
    },
    totalPending(){
      let total = 0
      this.filteredRqs.map(rqs => {
        total += rqs.containers.length
      })
      return total
    },
    filteredRqsFinished(){
      const { serviceSelected, portages, search, portCode } = this;
      const filterByService = portages.filter(
        pt =>
          pt.operation.code_service === serviceSelected &&
          pt.port.code === portCode && 
          pt.containers.length <= pt.containers.reduce((acum, ctn) => acum + ctn.used ,0)
          // pt.total_containers <= pt.progress_containers
      );
      return this.filterPortage(filterByService)
    },
    totalFinished(){
      let total = 0
      this.filteredRqsFinished.map(rqs => {
        total += rqs.containers.length
      })
      return total
    },
  },
  sockets: {
    connect: function() {
      console.log("conectado");
    },
    updateRatio(data) {
      let index = this.ports.findIndex(port => port.id == data.port_id);
      if (index >= 0 && data.ratio > 0) {
        this.ports[index].ratio_updated = data.ratio_updated;
        this.ports[index].ratio = data.ratio;
      }
    },
    updateCycleTime(data) {
      let index = this.ports.findIndex(port => port.id == data.port_id);
      if (index >= 0 && data.cycle_time > 0) {
        let minutes = data.cycle_time;

        var d = moment.duration(minutes, "minutes").asHours();
        var dur = moment.duration(d, "hours");

        var hours = Math.floor(dur.asHours());
        var mins = Math.ceil(minutes - hours * 60);
        this.ports[index].format_cycle_time =
          (hours > 9 ? hours : "0" + hours) +
          ":" +
          (mins > 9 ? mins : "0" + mins);
        this.ports[index].cycle_time_updated = data.cycle_time_updated; // moment(this.ports[index].cycle_time_updated).format('DD/MM/YYYY HH:mm')
        console.log(this.ports[index]);
      }
    }
  }
};
</script>
<style scoped>
.table tfoot td {
  font-size: 22px;
}
</style>

